export const chLoadingParams = {
  TITLE: 'title',
  TOOLTIP: 'tooltip',
  DEAD_LOAD: 'deadLoad',
  LIVE_LOAD: 'liveLoad',
  TEMPORARY_LOAD: 'temporaryLoad',
  ULTIMATE_LOAD: 'ultimateLoad',
  ACTION: 'action',
  ANIMATION_NAME: 'animationName'
};

export class ChLoading {

  constructor({ title, tooltip, deadLoad = 0, liveLoad = 0, temporaryLoad = 0, ultimateLoad = 0 }) {
    this[chLoadingParams.TITLE] = title.toLowerCase();
    this[chLoadingParams.DEAD_LOAD] = deadLoad;
    this[chLoadingParams.LIVE_LOAD] = liveLoad;
    this[chLoadingParams.TEMPORARY_LOAD] = temporaryLoad;
    this[chLoadingParams.ULTIMATE_LOAD] = ultimateLoad;
    this[chLoadingParams.ACTION] = title.indexOf('M') > -1 ? 'rotate': 'move';
    this[chLoadingParams.ANIMATION_NAME] = title[1];
    this[chLoadingParams.TOOLTIP] = tooltip;
  }

}



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/CharacteristicsLoading/ch-loading.class.js